.wrap {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.acts {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}

.blockers {
  margin: 0;
  padding-left: var(--sp-4);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  color: var(--muted);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  color: var(--crit);
  font-size: var(--fs-sm);
}

.note {
  margin: 0;
  color: var(--muted);
  font-size: var(--fs-sm);
}
